import {allPass, complement, isNil, pipe, prop, startsWith, pathEq, __} from 'ramda';

const notNullAnd = ([...fns]) => allPass([complement(isNil), ...fns]);

/**
 * @param {Alarm} alarm
 * @returns {boolean} Whether this alarm is of the Bypass type
 */
export const isBypassAlarm = notNullAnd([
  pipe(
    prop('text'),
    notNullAnd([
      startsWith('Bypass : '),
    ]),
  ),
]);

export const isCategory = notNullAnd([pathEq(['category'], __)]);
